import { render, staticRenderFns } from "./MovieRoom.vue?vue&type=template&id=67a2bd0b&"
import script from "./MovieRoom.vue?vue&type=script&lang=js&"
export * from "./MovieRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports